import React from "react";
import { useNavigate } from "react-router-dom";

import AuthCardFooter from "../../components/auth/AuthCardFooter";
import styles from "./AuthPage.module.css";

const PasswordUpdated = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.successBadge}>
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polyline points="5 12 10 17 19 8" />
        </svg>
      </div>
      <h1 className={`${styles.heading} ${styles.centerText}`}>
        Password updated
      </h1>
      <p className={`${styles.subheading} ${styles.centerText}`}>
        Your password has been changed successfully. You can now sign in with
        your new password.
      </p>

      <button
        type="button"
        className={styles.primaryBtn}
        onClick={() => navigate("/login", { replace: true })}
      >
        Go to Sign in
      </button>

      <AuthCardFooter />
    </>
  );
};

export default PasswordUpdated;
